import { render, staticRenderFns } from "./contact_panel.vue?vue&type=template&id=e152447e&scoped=true"
import script from "./contact_panel.vue?vue&type=script&lang=js"
export * from "./contact_panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e152447e",
  null
  
)

export default component.exports